import { render } from "./SubmitOtpView.vue?vue&type=template&id=6827dd49&scoped=true"
import script from "./SubmitOtpView.vue?vue&type=script&lang=js"
export * from "./SubmitOtpView.vue?vue&type=script&lang=js"

import "./SubmitOtpView.vue?vue&type=style&index=0&id=6827dd49&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6827dd49"]])

export default __exports__